import React from 'react';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { LinkWrapper } from '../../components/link-wrapper';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { BdiWrapper } from '../../components/bdi-wrapper';
import { cleanFont } from '../../utils/font-utils/clean-font';
import { addBorderClasses } from './common';
import { websiteContainer, contactContainer } from './styles';
import MobileDivider from './mobile-divider';
export const SiteTitleSection = (props) => {
    const { iconSrc, isRtl, isVisible, showBorderLeft, showBorderRight, text, textColor, url, width, hasTopDivider, section, paddingLeft, paddingRight, onSiteTitleClick, } = props;
    if (!isVisible) {
        return null;
    }
    const columnCssClass = `html-emails-footer-section ${addBorderClasses({
        showBorderRight,
        showBorderLeft,
        isRtl,
    })} bigger-column-height ${mobileFullWidthColumnClassName}`;
    const businessAddressStyle = { maxHeight: '100px' };
    const linkItems = (React.createElement(React.Fragment, null,
        React.createElement("span", { className: "so-global-footer-text", style: {
                ...(section.fontFamily
                    ? { fontFamily: cleanFont(section.fontFamily) }
                    : {}),
                ...contactContainer,
                ...(isRtl ? { display: 'inline' } : {}),
                color: textColor,
                ...businessAddressStyle,
            } },
            React.createElement(LinkWrapper, { fontWeight: "inherit" },
                React.createElement(BdiWrapper, { text: text }))),
        React.createElement(React.Fragment, null, ` `),
        React.createElement(React.Fragment, null, "\u00A0"),
        React.createElement("img", { className: "html-emails-footer-arrow-icon", height: 22, src: iconSrc, style: { verticalAlign: 'middle', border: '0' }, width: 22, alt: "" })));
    return (React.createElement(Column, { cssClass: columnCssClass, direction: isRtl ? 'rtl' : 'ltr', paddingRight: paddingRight, paddingLeft: paddingLeft, verticalAlign: "middle", width: width },
        hasTopDivider && (React.createElement(MobileDivider, { section: section, show: showBorderLeft })),
        React.createElement(Text, { align: "center", cssClass: "html-emails-footer-site-with-mobile-divider", padding: "0px 10px 0px 10px" },
            React.createElement("div", { style: websiteContainer },
                React.createElement("a", { className: "html-emails-footer-link", href: url, target: "_blank", onClick: onSiteTitleClick }, linkItems)))));
};
//# sourceMappingURL=footer-site-title.js.map